export default __webpack_public_path__ + "static/media/fog-learn.ff3c02ef.png";